<template>
  <v-container class="px-8">
    <div class="py-3 pl-2 flex-grow-0 flex-shrink-0">
      <div class="d-flex flex-row justify-space-between align-end">
        <div class="text-h4 font-weight-medium">
          {{ $t("navbar.menu.files") }}
        </div>
        <v-btn @click="$refs.files.click()" color="primary">
          {{ $t("files.add_new") }}
        </v-btn>
      </div>
    </div>
    <v-card min-width="700px">
      <DropZone @file="uploadFiles">
        <input type="file" multiple style="display: none" ref="files" @change="onFilesPicked" />
        <v-card-text v-if="Object.keys(files).length > 0">
          <v-row dense>
            <v-col v-for="(file, key) in files" :key="key" cols="6" md="3">
              <v-card>
                <div class="container">
                  <input
                    type="text"
                    class="red"
                    ref="textToCopy"
                    style="text-color: green"
                    :value="imageUrls[key]"
                    disabled
                    hidden
                  />
                  <v-card-text class="pb-0">
                    <v-img
                      cla
                      :src="isFilePdf(file) ? require('@/assets/pdf.png') : imageUrls[key]"
                      height="200px"
                    ></v-img>
                    <v-card-subtitle>{{ fileName(file) }}</v-card-subtitle>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn icon v-clipboard:copy="imageUrls[key]">
                      <v-icon>mdi-link</v-icon>
                    </v-btn>
                    <v-btn icon @click="download(fileName(file), imageUrls[key])">
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                    <v-btn icon :href="imageUrls[key]" target="_blank">
                      <v-icon>mdi-open-in-new</v-icon>
                    </v-btn>
                    <v-btn icon @click="fileToDelete = key">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
            <v-col v-if="loading" cols="6" md="3">
              <v-card>
                <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
                <v-skeleton-loader class="mx-auto" type="actions"></v-skeleton-loader>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text v-else>
          <v-card-title>
            {{ $t("files.noFiles") }}
          </v-card-title>
          <v-card-text>
            <v-btn class="mx-auto" @click="$refs.files.click()" color="primary">
              <v-icon left>mdi-plus-circle-outline</v-icon>
              {{ $t("common.add_new") }}
            </v-btn>
          </v-card-text>
        </v-card-text>
        <v-dialog v-if="fileToDelete" :value="fileToDelete != null" width="500">
          <v-card>
            <v-card-title class="headline primary white--text" primary-title
              >Delete file</v-card-title
            >
            <v-card-text class="mt-2"
              >{{ $t("files.qDelete") }} {{ fileName(files[fileToDelete]) }}?</v-card-text
            >
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="fileToDelete = null">{{
                $t("common.cancel")
              }}</v-btn>
              <v-btn color="error" @click="deleteFile()">{{ $t("common.delete") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="unsupportedFile" width="300">
          <v-card>
            <v-card-title class="headline primary white--text" primary-title>{{
              $t("files.fnotSupport")
            }}</v-card-title>
            <v-card-text class="mt-2">{{ $t("files.messageSupport") }}</v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="unsupportedFile = false">{{
                $t("common.ok")
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar">
          {{ $t("files.fileSuccess") }}
          <v-btn color="blue" text @click="snackbar = false">{{ $t("common.close") }}</v-btn>
        </v-snackbar>
      </DropZone>
    </v-card>
  </v-container>
</template>
<script>
import { uuid } from "vue-uuid";
import storage from "@/firebase/storage";
import database from "@/firebase/database";
import DropZone from "./DropZone";

export default {
  components: { DropZone },
  data: () => ({
    imageUrls: {},
    loading: false,
    unsupportedFile: false,
    snackbar: false,
    fileToDelete: null,
  }),
  computed: {
    files() {
      return this.$store.state.trip.files;
    },
  },
  methods: {
    download(filename, url) {
      const link = document.createElement("a");
      link.download = filename;
      link.href = url;
      link.target = "_blank";
      link.click();
    },
    isFilePdf(file) {
      return file.includes(".pdf");
    },
    deleteFile() {
      console.log("deleting file", this.$store.getters.currentTripId, this.fileToDelete);
      database.deleteFile(this.$store.getters.currentTripId, this.fileToDelete);
      this.fileToDelete = null;
    },
    getDownladUrls(files) {
      Object.entries(files).forEach(async ([key, file]) => {
        if (
          file.includes("jpg") ||
          file.includes("png") ||
          file.includes("jpeg") ||
          file.includes("pdf")
        ) {
          console.log("downloading url for ", file);
          const url = await storage.getDownloadURL(file);

          this.$set(this.imageUrls, key, url);
        }
      });
    },

    fileName(file) {
      const names = file.split("-");
      names.shift();
      return names.join("-");
    },

    async onFilesPicked(e) {
      const { files } = e.target;
      if (!files || files.length === 0) return;
      this.uploadFiles(Array.prototype.slice.call(files));
    },
    areFilesValid(files) {
      const allowedExtensions = ["pdf", "png", "jpg", "jpeg"];

      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const i in files) {
        const file = files[i];
        const extension = file.name.split(".").pop();
        if (!allowedExtensions.includes(extension)) {
          return false;
        }
      }
      return true;
    },
    async uploadFiles(files) {
      const tripId = this.$store.getters.currentTripId;

      if (!this.areFilesValid(files)) {
        this.unsupportedFile = true;
        return;
      }

      this.loading = true;
      files.forEach(async (file) => {
        let fileName = file.name.split(".");
        const id = uuid.v4().replace(/-/g, "");
        fileName.pop();
        fileName = fileName.join(".");
        const extension = file.name.split(".").pop().toLowerCase();

        const path = `groups/${tripId}/files/${id}-${fileName}.${extension}`;
        await storage.uploadFile(file, path);
        await database.addFile(tripId, path, id);
      });
      this.loading = false;
      this.snackbar = true;
    },
  },
  created() {
    console.log("created");
    this.getDownladUrls(this.files);
  },
  watch: {
    files(files) {
      console.log("files updated, fetching available urls");
      console.log(files);
      this.getDownladUrls(files);
    },
  },
};
</script>
